import { useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { auth } from '../FirebaseConfig';

const LogIn = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const signIn = (e) => {
        e.preventDefault();
        auth.signInWithEmailAndPassword(email, password).catch((err) => alert(err.message));
    }

    return(
        <div className = 'login'>
            <h4>Log In</h4>
            <Form className = 'loginForm'>
                <Form.Group controlId = 'formBasicEmail'>
                <Form.Label>Email address</Form.Label>
                <Form.Control type = 'email' placeholder='Enter email'
                    value = {email}
                    onChange = {(e) => setEmail(e.target.value)} required/>
                </Form.Group>
        
                <Form.Group controlId = 'formBasicPassword'>
                    <Form.Label>Password</Form.Label>
                    <Form.Control type = 'password' placeholder = 'Password'
                        value = {password}
                        onChange = {(e) => setPassword(e.target.value)} required/>
                </Form.Group>
                
                <Button variant = 'dark' type = 'submit' onClick = {signIn}>
                    Submit
                </Button>
            </Form>
        </div>
    );
}

export default LogIn;